import { createSlice } from "@reduxjs/toolkit";
import {
  fetchConfig,
  getProductsList,
  postConfig,
  postPartnerPdf,
  updateActiveDeactiveUser,
  uploadPicture,
  ArrangeCurrencies,
  postSubProductList,
  fetchFederalConfig
} from "./action";
import { ProductsList } from "../constant/Stepper";

const initialState = {
  configData: {},
  fedConfigData:{},
  childConfigData: {},
  configMessage: "",
  configType: "",
  isConfigLoader: false,
  assumptions: {},
  selectedProduct: [ProductsList[0]],
  products: [],
} as unknown as {
  configData: Record<string, any>;
  childConfigData: Record<string, any>;
  configMessage: string;
  configType: string;
  isConfigLoader: boolean;
  assumptions: Record<string, any>;
  selectedProduct: Array<any>;
  products: Array<any>;
  fedConfigData: any;
};

const isAnyOf =
  (...matchers: any) =>
    (action: any) =>
      matchers.some((matcher: any) =>
        typeof matcher === "string"
          ? matcher === action.type
          : matcher.type === action.type
      );

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    handleConfigError: (state) => {
      state.configMessage = "";
      state.configType = "";
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getProductsList.fulfilled, (state, { payload }) => {
        if (payload.status === 200) {
          state.products = payload ? payload?.data?.data : {};
        }
        return state;
      })
      .addCase(postSubProductList.fulfilled, (state, { payload }) => {
        if (payload.status === 200) {
          state.configMessage = payload.data.message;
          state.configType = "success";
        }
        return state;
      })
      .addCase(fetchConfig.fulfilled, (state, { payload }) => {
        state.isConfigLoader = false;
        if (payload.status === 200) {
          state.configData = payload ? payload?.data?.data : {};
          state.assumptions = payload.data.assumptions;
        }
        return state;
      })
      .addCase(fetchFederalConfig.fulfilled, (state, { payload }) => {
        state.isConfigLoader = false;
        if (payload.status === 200) {
          state.fedConfigData = payload ? payload?.data?.data : {};
          state.assumptions = payload.data.assumptions;
        }
        return state;
      })
      .addCase(postConfig.fulfilled, (state, { payload }) => {
        state.isConfigLoader = false;
        if (payload.status === 200) {
          state.configMessage = payload.data.message;
          state.configType = "success";
        }
        return state;
      })
      .addCase(ArrangeCurrencies.fulfilled, (state, { payload }) => {
        state.isConfigLoader = false;
        if (payload.status === 200) {
          state.configMessage = "Currency Updated Successfully";
          state.configType = "success";
        }
        return state;
      })
      .addCase(updateActiveDeactiveUser.fulfilled, (state, { payload }) => {
        state.isConfigLoader = false;
        if (payload.status === 200) {
          state.configMessage = payload.data.message;
          state.configType = "success";
        }
        return state;
      })
      .addCase(postPartnerPdf.fulfilled, (state, { payload }) => {
        if (payload.status === 200) {
          state.configMessage = payload.data.message;
          state.configType = "success";
        }
        return state;
      })
      .addCase(uploadPicture.fulfilled, (state, { payload }) => {
        if (payload.status === 200) {
          state.configMessage = payload.data.message;
          state.configType = "success";
        }
        return state;
      })
      .addMatcher(isAnyOf(fetchConfig.pending), (state) => {
        return {
          ...state,
          isConfigLoader: true,
        };
      })
      .addMatcher(isAnyOf(fetchFederalConfig.pending), (state) => {
        return {
          ...state,
          isConfigLoader: true,
        };
      })
});

export const { handleConfigError } = configSlice.actions;

export default configSlice.reducer;
